import { render } from "./MyIndexes.vue?vue&type=template&id=389828da&scoped=true"
import script from "./MyIndexes.vue?vue&type=script&lang=js"
export * from "./MyIndexes.vue?vue&type=script&lang=js"

import "./MyIndexes.vue?vue&type=style&index=0&id=389828da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389828da"]])

export default __exports__